import confetti from "canvas-confetti"

export function fireConfetti() {
    confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
        colors: ['#8f4420', '#5A2924', '#EC6D2D', '#ffffff'],
    })
}
